import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import './UIUXHero.css';

const UIUXHero = () => {
  return (
    <Box className="uiux-hero">
      <div className="uiux-hero-overlay" />
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <motion.div
          className="uiux-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="subtitle1"
            className="uiux-hero-subtitle-top"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Our Services
          </Typography>
          <Typography
            variant="h1"
            className="uiux-hero-title"
            component={motion.h1}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            UI/UX DESIGN
          </Typography>
          <Typography
            className="uiux-hero-description"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Transform your digital presence with our innovative UI/UX design solutions. 
            We create intuitive, engaging, and user-centered experiences that delight your 
            customers and drive business growth. Our expert team combines creativity with 
            data-driven insights to deliver exceptional digital experiences.
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default UIUXHero; 